import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lessonString'
})
export class LessonStringPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    let v1 = value % 100;
    let v2 = value % 10;
    let res: string = value.toString() + ' ';
    if (v1 > 10 && v1 < 20) {
      res+=args[2]; 
      return res; 
    }
    if (v2 > 1 && v2 < 5) { 
      res+=args[1];
      return res; 
    }
    if (v2 == 1) { 
      res+=args[0];
      return res;  
    }
    res+=args[2];
    return res;
  }

}
